export enum PopoverBackgroundType {
  WITH_BORDER_GRADIENT = "withBorderGradient",
  WITH_GRADIENT = "withGradient",
  WITHOUT_GRADIENT = "withoutGradient"
}

interface PopoverBackgroundStyle {
  background: string;
  backgroundSize: string;
  border?: string;
}

const POPOVER_BACKGROUND_STYLES: Record<
  PopoverBackgroundType,
  PopoverBackgroundStyle
> = {
  [PopoverBackgroundType.WITH_BORDER_GRADIENT]: {
    background: `
      radial-gradient(circle at 1.5px 1.5px, rgba(255, 255, 255, 0.07) 0.8px, transparent 0),
      radial-gradient(180% 180% at 80% 100%, rgba(0, 85, 255, 0.3) 0%, rgba(0, 85, 255, 0.1) 25%, rgba(4, 7, 11, 0) 50%),
      linear-gradient(#161E2C, #161E2C) padding-box,
      linear-gradient(60deg, rgba(0, 245, 163, 0.4), rgba(77, 166, 255, 0.4), rgba(77, 166, 255, 0.4)) border-box,
      #161E2C
    `,
    backgroundSize: "5px 5px, cover, cover, cover, cover",
    border: "1px solid transparent"
  },
  [PopoverBackgroundType.WITH_GRADIENT]: {
    background: `
      radial-gradient(circle at 1.5px 1.5px, rgba(255, 255, 255, 0.07) 0.8px, transparent 0),
      radial-gradient(180% 180% at 80% 100%, rgba(0, 85, 255, 0.3) 0%, rgba(0, 85, 255, 0.1) 25%, rgba(4, 7, 11, 0) 50%),
      #161E2C
    `,
    backgroundSize: "5px 5px, cover, cover, cover"
  },
  [PopoverBackgroundType.WITHOUT_GRADIENT]: {
    background: `
      radial-gradient(circle at 1.5px 1.5px, rgba(255, 255, 255, 0.07) 0.8px, transparent 0),
      #161E2C
    `,
    backgroundSize: "5px 5px, cover"
  }
};

export const getPopoverBackgroundStyle = (
  hasBorderClassName: boolean,
  showBackgroundGradient: boolean
): PopoverBackgroundStyle => {
  if (hasBorderClassName) {
    return showBackgroundGradient
      ? POPOVER_BACKGROUND_STYLES[PopoverBackgroundType.WITH_GRADIENT]
      : POPOVER_BACKGROUND_STYLES[PopoverBackgroundType.WITHOUT_GRADIENT];
  }
  return POPOVER_BACKGROUND_STYLES[PopoverBackgroundType.WITH_BORDER_GRADIENT];
};
